<button
  id="icon-40px-button"
  [className]="typeBtn"
  [disabled]="isDisabled"
  matRipple
>
  <div id="{{ name }}-icon" class="mat-icon-custom"></div>
</button>
